document.querySelectorAll( '.b-location-map' ).forEach( ( block ) => {

	const mapArea = block.querySelector( '.b-location-map__map-area' );

	if ( !mapArea ) {

		return;

	}

	// Get map URL from block data attribute (set by PHP).
	const mapUrl = block.dataset.mapUrl;

	if ( mapUrl ) {

		loadCountryMap( mapUrl, mapArea );

	}

	/**
	 * Load country map SVG
	 *
	 * @param {string} url Full URL to SVG file
	 * @param {Element} mapContainer Map container element
	 */
	function loadCountryMap( url, mapContainer ) {

		if ( !url || !mapContainer ) {

			return;

		}

		mapContainer.innerHTML = '<div class="b-location-map__loading">Loading map...</div>';

		fetch( url )
			.then( response => {

				if ( !response.ok ) {

					throw new Error( 'Map not found' );

				}

				return response.text();

			} )
			.then( svgContent => {

				mapContainer.innerHTML = svgContent;

			} )
			.catch( () => {

				mapContainer.innerHTML = '<div class="b-location-map__no-map">Map not available</div>';

			} );

	}

} );
